import React, {Component, PropTypes} from 'react'
import Cannonicalize from '../Cannonicalize'
import Carousel from '../Carousel'
import VideoPlayer from '../FranklyVideoPlayerAdapter';
import HelperDarkBackground from '../HelperDarkBackground'
import Analytics from '../Analytics';

const LeftControl = (props)=> <span className="fa fa-chevron-left fa-caret-left fa-angle-left" aria-hidden="true"><span className="sr-only">Previous</span></span>
const RightControl = (props) => <span className="fa fa-chevron-right fa-caret-right fa-angle-right" aria-hidden="true"> <span className="sr-only">Next</span></span>

class SkycamPage extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.state = {
      cams: [],
      feature: {},
      poster: '',
      videoSrcs :[]
    }
    this.initTime = Date.now()
  }

  componentWillMount() {

    try {

      this.setState( {cams: Cannonicalize.skyCam(this.props.FRN_rawResponses[0].data)})
    } catch (e) {
      e.message += 'in SkycamPage'
      Analytics.reportError()

    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('skyCam').then((res) => {
      this.setState({cams: res}, this.selectDefaultCam)
    })
  }

  selectDefaultCam = () =>{
    let selectedCam = this.state.cams[0]
    if(typeof this.props.params.id === 'string'){
      let id = this.props.params.id
      for (var i = 0; i < this.state.cams.length; i++) {
        if(this.state.cams[i].id === id){
            selectedCam = this.state.cams[i]
            break;
        }

      }
    }

    this.selectCam(selectedCam)
  }

  selectCam = (c)=>{
    this.setState({
      feature: c,
      poster: c.poster,
      videoSrcs:[
        {
          src: c.movie_path + '_cam.mp4',
          type: "video/mp4"
        }
      ]
    })
  }


  render() { // REQUIRED
    return (
      <div className='gnm-skycam-page'>
        <HelperDarkBackground />
        <div className="row">
            <div className="col-lg-8">
              <VideoPlayer sources={this.state.videoSrcs} poster={this.state.poster} autoPlay={true}/>
              <h3 className='white-at-small'>{this.state.feature.cam_name}</h3>
              <p className='white-at-small trademark-permission'>SkyCam is a registered trademark and is being used with permission from SkyCam LLC.</p>
            </div>
            <div className="col-lg-4">
              <div className='row'>
                <div className='col-sm-12 col-md-6 col-lg-12'>
                  <div className='list-container'>
                    {this.state.cams.map((c,i,a)=>{
                      return(
                        <div className='row no-gutter' key={i} style={{backgroundColor: c.id === this.state.feature.id ? 'white' : null}}>
                          <a href='#' onClick={()=>{this.selectCam(c)}}>
                            <div className='col-xs-6'>
                              <img
                                src={c.poster}

                                aria-label={c.cam_name}
                                className='img-responsive thumb'
                                onError={(e)=>{e.target.src="https://ftpcontent.worldnow.com/griffin/NEXGEN_Images/imageNotFound16x9.png";
                                                let error = new Error('*Back-End* Skycam Image at path ' + c.poster + ' is not responding ');
                                                Analytics.reportError(error);
                                              }}/>
                            </div>
                            <div className='col-xs-6'>
                              <b>{c.cam_name}</b>
                            </div>
                          </a>
                        </div>
                      )
                    })}
                  </div>
                </div>
                <div className='col-sm-12 col-md-6 col-lg-12'>

                  <a className='map' href="https://ftpcontent.worldnow.com/kwtv/custom/marketing/skycam/TulsaSkycamNetwork.pdf">
                    <h6 className='white-at-small'>Skycam Network Map</h6>
                    <img src="https://ftpcontent.worldnow.com/kwtv/custom/marketing/skycam/tulsa_map.jpg" className="img-responsive"/>
                  </a>
                  <div className='white-at-small description'>Real Time cameras display the latest camera images & update every 10 seconds. The 24-hour Time-Lapse displays footage of the last 24 hours & updates every 15 minutes.</div>

                </div>
              </div>

            </div>
         </div>


      </div>
    )
  }
}

export default SkycamPage



// WEBPACK FOOTER //
// ./app/components/custom/ssr/SkycamPage/index.js